import { ref } from "vue";
import { Channel } from "../services/channel";

export function createReportsChannel(onUpdate=null, params=null) {
  var channel = new ReportsChannel(onUpdate, params);
  channel.connect();
  return channel;
}

class ReportsChannel extends Channel {
  constructor(onUpdate, params) {
    super("Reporting::ReportsChannel", params);
    this.onUpdate = onUpdate ?? (()=>{});
  }

  received(data) {
    data.forEach(report => this.onUpdate(report));
  }
}
